import styled from "styled-components";

export const WrapperShadow = styled.div`
    box-shadow: 0 1px 2px #00000057;
`;

export const Wrapper = styled.div`
    max-width: 1200px;
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    margin: 0 auto 20px;
`;

export const Logo = styled.div`
    font-size: 24px;
    font-weight: 500;
`;
export const LinkGroups = styled.div`
    //border: solid 1px red;
    display: flex;
    flex-direction: row;
    gap: 34px;
`
export const Link = styled.div`
    font-size: 24px;
`
